import { useState } from 'react'

import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { pageForGeneralFormFromDTO } from './api/mapper'
import { GET_PAGE } from './api/query'
import { Data, Variables } from './api/types'
import { PageForGeneralForm, UseGetPage, UseGetPageProps } from './types'

export const useGetPage = ({ id }: UseGetPageProps): UseGetPage => {
  const ability = useAbility()
  const [page, setPage] = useState<PageForGeneralForm>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node: page } = data

      if (page) {
        setPage(pageForGeneralFormFromDTO(page))
      }
    },
    options: {
      enabled: id !== undefined,
    },
    query: GET_PAGE(ability),
    variables: { id: id! },
  })

  return { loading, page }
}
